import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PlaneIcon, CarIcon, HomeIcon, UsersIcon, MoonIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Services() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Private transport services in Ibiza',
      intro: 'From airport arrivals to villa transfers, private driver hire and group transport — we cover every journey across Ibiza.',
      services: [{
        title: 'Airport Transfer Ibiza',
        desc: 'Private airport pickup and drop-off. Driver waits at arrivals with your name. No queues.',
        icon: PlaneIcon,
        link: '/ibiza-airport-transfer'
      }, {
        title: 'Villa Transfers Ibiza',
        desc: 'Direct transfers to villas with easy access and local drivers. We know every road, gate and shortcut in Ibiza.',
        icon: HomeIcon,
        link: '/ibiza-villa-transfer'
      }, {
        title: 'Group Transfers Ibiza',
        desc: 'Comfortable transport for couples, families and groups up to 16 passengers. Spacious vehicles, easy booking.',
        icon: UsersIcon,
        link: '/ibiza-group-transfer'
      }, {
        title: 'Night Out Driver Ibiza',
        desc: 'Private driver for nightlife, clubs and dinners. Wait & return service included.',
        icon: MoonIcon,
        link: '/ibiza-night-driver'
      }]
    },
    es: {
      title: 'Servicios de transporte privado en Ibiza',
      intro: 'Desde llegadas al aeropuerto hasta traslados a villas, chófer privado y transporte de grupos — cubrimos cada trayecto en Ibiza.',
      services: [{
        title: 'Transfer Aeropuerto Ibiza',
        desc: 'Recogida y traslado privado en el aeropuerto. Tu conductor te espera en llegadas con tu nombre. Sin colas, sin estrés.',
        icon: PlaneIcon,
        link: '/ibiza-airport-transfer'
      }, {
        title: 'Traslados a Villas Ibiza',
        desc: 'Traslados directos a villas con acceso fácil y conductores locales. Conocemos cada camino, puerta y atajo en Ibiza.',
        icon: HomeIcon,
        link: '/ibiza-villa-transfer'
      }, {
        title: 'Traslados para Grupos Ibiza',
        desc: 'Transporte cómodo para parejas, familias y grupos de hasta 16 pasajeros. Vehículos amplios, reserva fácil.',
        icon: UsersIcon,
        link: '/ibiza-group-transfer'
      }, {
        title: 'Chófer Nocturno Ibiza',
        desc: 'Chófer privado para vida nocturna, clubs y cenas. Servicio de espera y regreso incluido.',
        icon: MoonIcon,
        link: '/ibiza-night-driver'
      }]
    }
  };
  const text = content[language];
  return <section id="services" className="py-12 md:py-20 bg-warm-white border-t border-stone/10" data-id="element-292">
      <div className="mx-auto max-w-7xl px-5" data-id="element-293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-294">
          <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-295">
            {text.title}
          </h2>
          <div className="w-12 h-px bg-gold-subtle/50 mx-auto mb-5" data-id="element-296" />
          <p className="text-slate leading-relaxed" data-id="element-297">{text.intro}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 justify-center" data-id="element-298">
          {text.services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} data-id="element-299">
                <Link to={service.link} className="block h-full bg-white p-6 md:p-7 rounded-xl border border-stone/10 shadow-sm hover:shadow-md hover:border-gold-subtle/30 transition-all group" data-id="element-300">
                  <div className="w-10 h-10 rounded-lg bg-navy/[0.04] flex items-center justify-center text-navy mb-4 group-hover:bg-gold-subtle/10 group-hover:text-gold-subtle transition-colors" data-id="element-301">
                    <Icon className="w-5 h-5" data-id="element-302" />
                  </div>
                  <h3 className="text-base font-heading text-navy mb-2 flex items-center justify-between" data-id="element-303">
                    <span data-id="element-304">{service.title}</span>
                    <ArrowRightIcon className="w-4 h-4 text-stone/40 group-hover:text-gold-subtle transition-colors" data-id="element-305" />
                  </h3>
                  <p className="text-slate text-sm leading-relaxed" data-id="element-306">
                    {service.desc}
                  </p>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}